import messages from './messages'
import channels from './channels'

export default {
  messages,
  channels
}
